import { styles as componentStyles } from './view.scss';
import { styles as commonStyles } from '../../../../../../../src/assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../../../assets/color-helpers.scss';
import { styles as textHelpersStyles } from '../../../../../../assets/text-helpers.scss';
import { styles as styleHelpers } from '../../../../../../assets/style-helpers.scss';
import { unsafeCSS } from 'lit';

export const styles = [
  unsafeCSS(`${commonStyles}`),
  unsafeCSS(`${componentStyles}`),
  unsafeCSS(`${colorHelpersStyles}`),
  unsafeCSS(`${styleHelpers}`),
  unsafeCSS(`${textHelpersStyles}`),
];
